var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendDownGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 4,
    fill: "#EBF7EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5938 23.625H12.2812C11.6797 23.625 11.25 23.1953 11.25 22.5938C11.25 22.0352 11.6797 21.5625 12.2812 21.5625H20.1016L10.1758 11.6367C9.74609 11.25 9.74609 10.6055 10.1758 10.1758C10.5625 9.78906 11.207 9.78906 11.6367 10.1758L21.5625 20.1445V12.2812C21.5625 11.7227 21.9922 11.25 22.5938 11.25C23.1523 11.25 23.625 11.7227 23.625 12.2812V22.5938C23.625 23.1953 23.1523 23.625 22.5938 23.625Z",
    fill: "#74AA85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDownGreen);
export default __webpack_public_path__ + "static/media/trend-down-green.12d221be433f6942354d4f31fbebed7e.svg";
export { ForwardRef as ReactComponent };